module.exports = __webpack_public_path__ + "img/check-circle-white.250b390f.svg";